import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=01a287c7&scoped=true"
import script from "./submitSuccess.vue?vue&type=script&lang=js"
export * from "./submitSuccess.vue?vue&type=script&lang=js"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=01a287c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a287c7",
  null
  
)

export default component.exports